import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const problems = [{
  num: '01 / 02',
  title: 'El problema que nadie te dice: la medicación que salva también cambia',
  sin: 'Usás el antiepiléptico todos los días para que tu hijo no tenga convulsiones, sin saber que ese mismo medicamento puede estar causando la irritabilidad extrema, el sueño fragmentado, los cambios de personalidad y las dificultades de aprendizaje que estás viendo.',
  con: 'Tenés la guía completa de efectos conductuales de los antiepilépticos más usados en Argentina, con el protocolo para distinguir qué es la epilepsia, qué es la medicación y qué es otra cosa. Con herramientas concretas para hablar con el neurólogo y pedir ajustes.'
}, {
  num: '02 / 02',
  title: 'El problema de la obra social que te dice que no',
  sin: 'La prepaga te rechaza el medicamento de marca, te demora el EEG, te niega la cobertura de la terapia ocupacional o no te reconoce el CUD. No sabés si tenés razón, no sabés cómo reclamar, no sabés qué ley los ampara.',
  con: 'Tenés el protocolo completo de reclamo para obras sociales y prepagas en Argentina: cartas documento modelo, pasos para pedir el amparo, derechos bajo la Ley de Epilepsia, cómo tramitar el CUD y cómo conseguir la cobertura de terapias complementarias.'
}];
export const MasterKitExplanation = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-white" data-id="element-154">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="text-center mb-8 sm:mb-12 md:mb-16" data-id="element-156">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-157">
            ¿QUÉ AGREGA EL KIT EPILEPSIA BAJO CONTROL PRO™?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-brand-orange font-medium" data-id="element-158">
            Para madres que quieren también manejar la conducta y los derechos
            de su hijo
          </p>
        </div>

        <div className="space-y-4 sm:space-y-6 md:space-y-8" data-id="element-159">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          y: -3,
          transition: {
            duration: 0.2
          }
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35
        }} className="bg-cream-dark rounded-2xl p-4 sm:p-5 md:p-6 border border-brand-gold/20 shadow-sm cursor-default" data-id="element-160">
              <div className="flex flex-col md:flex-row md:items-center gap-3 sm:gap-4 mb-4 sm:mb-6" data-id="element-161">
                <span className="text-brand-gold font-heading font-bold text-lg sm:text-xl" data-id="element-162">
                  {prob.num}
                </span>
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900" data-id="element-163">
                  {prob.title}
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6" data-id="element-164">
                <div className="bg-white p-4 sm:p-5 rounded-xl border border-red-100" data-id="element-165">
                  <div className="flex items-center gap-2 text-red-600 font-bold mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-166">
                    <XCircle size={16} data-id="element-167" /> Sin Kit PRO
                  </div>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed" data-id="element-168">
                    {prob.sin}
                  </p>
                </div>

                <div className="bg-brand-green/5 p-4 sm:p-5 rounded-xl border border-brand-green/20" data-id="element-169">
                  <div className="flex items-center gap-2 text-brand-green font-bold mb-2 sm:mb-3 text-sm sm:text-base" data-id="element-170">
                    <CheckCircle2 size={16} data-id="element-171" /> Con Kit PRO
                  </div>
                  <p className="text-gray-800 text-xs sm:text-sm leading-relaxed font-medium" data-id="element-172">
                    {prob.con}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};